import { type FC } from "react";
import { useParams } from "react-router-dom";
import { useAffectedGroups } from "../hooks/useAffectedGroups";
// import { AppParams } from "../../routes/types";
import { AffectedGroupsView } from "../components/AffectedGroupsView";
import { type AffectedGroupModel } from "../models";

interface AffectedGroupsContainerProps {
    lensSourceId: string;
}

export const AffectedGroupsContainer: FC<AffectedGroupsContainerProps> = ({ lensSourceId }) => {
    const { affectedGroups, loading, loadMore, isLastPage } = useAffectedGroups(lensSourceId);
    // TODO: UNCOMMENT ROUTES
    const { orgId } = useParams();

    return (
        <AffectedGroupsView
            affectedGroups={affectedGroups as readonly AffectedGroupModel[]}
            loading={loading}
            loadMore={loadMore}
            isLastPage={isLastPage}
            organizationId={orgId ?? ""}
        />
    );
};
